<div class="saveSearch-dialog">
  <div mat-dialog-title>
    <h1>
      {{ dialogConfig.title | xTranslate }}
    </h1>
    <div class="title-actions">
      <mat-icon id="e2e-close-dialog-btn" class="dialog__close" mat-dialog-close>close</mat-icon>
    </div>
  </div>

  <!-- Dialog Button Actions-->
  <div mat-dialog-content>
    <form [formGroup]="searchFormGroup">
      <div class="add-folders">
        <label l10nTranslate>recordsSearch.addToFolder</label>
        <div [matMenuTriggerFor]="menu" class="add-folders-display">
          {{ selectedFolderName ? selectedFolderName : ('recordsSearch.none' | xTranslate) }}
        </div>

        <mat-menu #menu="matMenu" class="folder-selector">
          <miq-create-select-folders
            [nodes]="foldersList | async"
            [expandableOptions]="expandableOptions"
            [selectionModeOnly]="false"
            [enableNone]="true"
            [nodeDataParser]="nodeDataParser"
            [hasNoContent]="hasNoContent"
            (itemSelected)="setSelectedFolder($event)"
            (itemCreated)="saveNode($event)"
          >
          </miq-create-select-folders>
        </mat-menu>
      </div>

      <div class="name-container-inputs">
        <div class="name-container">
          <label>
            {{ 'recordsSearch.name' | xTranslate | titlecase }}<span class="required-icon"> &#x2a; </span>
          </label>
          <mat-form-field appearance="outline" class="miq-form-input">
            <input autocomplete="no-autofill" matInput type="text" formControlName="name" required maxlength="50" />
          </mat-form-field>
          <mat-hint l10nTranslate>recordsSearch.sixtyCharactersLimit</mat-hint>
          <mat-error class="empty-name-class" *ngIf="showEmptyInputError" l10nTranslate>
            recordsSearch.nameOrLettercannotEmpty
          </mat-error>
        </div>

        <div class="namelocation-input">
          <label>{{ 'recordsSearch.description' | xTranslate | titlecase }}</label>
          <mat-form-field appearance="outline" class="text-area miq-form-input">
            <textarea
              matInput
              rows="2"
              autocomplete="no-autofill"
              formControlName="description"
              maxlength="150"
            ></textarea>
          </mat-form-field>
          <mat-hint l10nTranslate>recordsSearch.150CharactersLimit</mat-hint>
        </div>
      </div>

      <div class="geo-fields-wrapper">
        <div class="flex-grid wrap">
          <!-- Geography Fields -->
          <ng-container *ngIf="dialogConfig.geoFields">
            <div class="report-dialog-input" *ngFor="let fields of dialogConfig.geoFields; let i = index">
              <div class="filter-label">
                <label>
                  {{ geoLabelsLocaleKeys[fields.key] | xTranslate | titlecase }}
                  <span class="required-icon" *ngIf="fields.required"> &#x2a; </span>
                </label>
                <mat-icon
                  *ngIf="fields.tooltip"
                  svgIcon="mapinfo-icon"
                  class="icon-class ml-2"
                  [matTooltip]="fields.tooltip | xTranslate"
                ></mat-icon>
              </div>
              <ng-container
                *ngIf="
                  fields.key === propertyTypes || (historicalStatChanges && corporateDialogFields.includes(fields.key));
                  else otherFields
                "
              >
                <div *ngIf="dialogConfig.templateId; else propertyTypeMultiSelect" class="market-select">
                  <p-select
                    class="primeng-dropdown"
                    [options]="fields.options"
                    [formControlName]="fields.key"
                    [appendTo]="'body'"
                    [filter]="true"
                    filterBy="label"
                    [resetFilterOnHide]="true"
                    [autofocus]="true"
                    [showClear]="true"
                    [style]="{ width: '100%' }"
                    [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                  >
                    <ng-template let-propertyType pTemplate="selectedItem">
                      <div>{{ propertyType.label }}</div>
                    </ng-template>
                    <ng-template let-option pTemplate="item">
                      <div>{{ option.label }}</div>
                    </ng-template>

                    <!-- Clear icon-->
                    <ng-template pTemplate="clearicon">
                      <i class="pi pi-times-circle property-multiselect-clear"></i>
                    </ng-template>
                  </p-select>
                </div>
                <ng-template #propertyTypeMultiSelect>
                  <div class="market-select">
                    <p-multiSelect
                      class="primeng-multiselect"
                      [options]="fields.options"
                      id="e2e-Market"
                      [appendTo]="'body'"
                      [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                      displaySelectedLabel="false"
                      selectedItemsLabel="{0} {{ geoLabelsLocaleKeys[fields.key] | xTranslate | titlecase }}"
                      [style]="{ width: '100%' }"
                      [formControlName]="fields.key"
                      [disabled]="!fields.options?.length"
                      [resetFilterOnHide]="true"
                      (onChange)="geoValuesChanges($event, i)"
                    ></p-multiSelect>
                    <i
                      *ngIf="searchFormGroup.controls[fields.key].value?.length"
                      aria-label="Close icon"
                      class="pi pi-times-circle multiselect-clear"
                      (click)="resetGeoFields(i, 1)"
                    >
                    </i>
                  </div>
                </ng-template>
              </ng-container>

              <ng-template #otherFields>
                <div class="market-select">
                  <ng-container *ngIf="!dialogConfig.singleGeoFields; else singleFields">
                    <p-multiSelect
                      class="primeng-multiselect"
                      [options]="fields.options"
                      id="e2e-Market"
                      [appendTo]="'body'"
                      [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                      displaySelectedLabel="false"
                      selectedItemsLabel="{0} {{ geoLabelsLocaleKeys[fields.key] | xTranslate | titlecase }}"
                      [style]="{ width: '100%' }"
                      [formControlName]="fields.key"
                      [disabled]="!fields.options?.length"
                      [resetFilterOnHide]="true"
                      (onChange)="geoValuesChanges($event, i)"
                    ></p-multiSelect>
                    <i
                      *ngIf="searchFormGroup.controls[fields.key].value?.length"
                      aria-label="Close icon"
                      class="pi pi-times-circle multiselect-clear"
                      (click)="resetGeoFields(i, 1)"
                    >
                    </i>
                  </ng-container>
                  <ng-template #singleFields>
                    <p-select
                      class="primeng-dropdown"
                      [options]="fields.options"
                      [formControlName]="fields.key"
                      [appendTo]="'body'"
                      [filter]="true"
                      filterBy="label"
                      [resetFilterOnHide]="true"
                      [autofocus]="true"
                      [disabled]="!fields.options?.length"
                      [showClear]="true"
                      [style]="{ width: '100%' }"
                      [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                      (onChange)="geoValuesChanges($event, i)"
                    >
                      <!-- Clear icon-->
                      <ng-template pTemplate="clearicon">
                        <i class="pi pi-times-circle property-multiselect-clear"></i>
                      </ng-template>
                    </p-select>
                  </ng-template>
                </div>
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngIf="dialogConfig.selectInitialPeriod">
            <div class="form-fields report-dialog-input" *ngIf="!dialogConfig.defaultPeriodType">
              <label class="period-label ml-2">
                {{ 'recordsSearch.periodType' | xTranslate | titlecase }} <span class="required-icon"> * </span>
              </label>
              <mat-form-field appearance="outline">
                <mat-select
                  hideSingleSelectionIndicator="true"
                  formControlName="periodType"
                  (selectionChange)="periodTypeChange()"
                  disableOptionCentering
                >
                  <mat-option *ngIf="historicalStatChanges" value="monthly">{{
                    'recordsSearch.monthly' | xTranslate
                  }}</mat-option>
                  <mat-option value="quarterly">{{ 'recordsSearch.quarterly' | xTranslate }}</mat-option>
                  <mat-option value="yearly">{{
                    (historicalStatChanges ? 'recordsSearch.annual' : 'recordsSearch.yearly') | xTranslate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="selectdate-input report-dialog-input">
              <div class="filter-label">
                <label l10nTranslate> recordsSearch.period <span class="required-icon"> &#x2a; </span> </label>
              </div>
              <cbre-miq-quarter-selector
                [singleSelection]="!!!dialogConfig.selectFinalPeriod"
                [type]="periodTypeControl.value"
                [value]="period.value"
                (valueChange)="period.setValue($event)"
                [maxValue]="maxDate"
                [showAsQtd]="true"
              ></cbre-miq-quarter-selector>
            </div>
          </ng-container>
          <ng-container *ngIf="dialogConfig.selectReportType || dialogConfig.selectReportEntity">
            <div class="form-fields report-dialog-input">
              <label l10nTranslate> recordsSearch.reportType </label>
              <mat-radio-group formControlName="reportType">
                <mat-radio-button *ngFor="let type of reportTypes" [value]="type">
                  {{ 'recordsSearch.reportType' + type | xTranslate }}
                </mat-radio-button>
                <mat-icon
                  *ngIf="entity === 'availability' && dialogConfig.selectReportType"
                  svgIcon="mapinfo-icon"
                  class="icon-class ml-2"
                  [matTooltip]="'recordsSearch.reportTypetagOutputDesc' | xTranslate"
                ></mat-icon>
              </mat-radio-group>
            </div>
          </ng-container>

          <!-- Filter Inputs-->
          <!-- Number Range Inputs, currently used by National TIM reports -->
          <ng-container *ngIf="dialogConfig.sizeMin">
            <ng-container
              [ngTemplateOutlet]="numberRangeInput"
              [ngTemplateOutletContext]="{ rangeConfig: dialogConfig.sizeMin }"
            ></ng-container>
          </ng-container>

          <!-- Number Range Inputs, currently used by National TIM reports -->
          <ng-container *ngIf="dialogConfig.sizeMax">
            <ng-container
              [ngTemplateOutlet]="numberRangeInput"
              [ngTemplateOutletContext]="{ rangeConfig: dialogConfig.sizeMax }"
            ></ng-container>
          </ng-container>

          <!-- Dropdown Status Input, currently used by Top Transactions and National TIM reports -->
          <ng-container *ngIf="dialogConfig.statuses && dialogConfig.statuses.isVisible">
            <!--
                                    NOTE: do not use title case pipe on places with variable label
                                    values as it may transform "TIM" label to "Tim"
                                  -->
            <div class="report-dialog-input">
              <div class="filter-label">
                <label>{{ dialogConfig.statuses.labelKey | xTranslate }}</label>
              </div>
              <div class="market-select">
                <p-multiSelect
                  class="primeng-multiselect"
                  [options]="dialogConfig.statuses.data"
                  [appendTo]="'body'"
                  [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                  displaySelectedLabel="false"
                  selectedItemsLabel="{0} {{ dialogConfig.statuses.labelKey | xTranslate }}"
                  [style]="{ width: '100%' }"
                  [formControlName]="dialogConfig.statuses.key"
                  [disabled]="!dialogConfig.statuses.data?.length"
                  [resetFilterOnHide]="true"
                ></p-multiSelect>
                <i
                  *ngIf="searchFormGroup.controls[dialogConfig.statuses.key].value?.length"
                  class="pi pi-times-circle multiselect-clear"
                  aria-label="Close icon"
                  (click)="clearValue(dialogConfig.statuses.key)"
                >
                </i>
              </div>
            </div>
          </ng-container>

          <!-- Dropdown Statisticals Input, currently used by Corporate Reports -->
          <ng-container *ngIf="dialogConfig.statisticals">
            <!--
                                    NOTE: do not use title case pipe on places with variable label
                                    values as it may transform "TIM" label to "Tim"
                                  -->
            <div class="report-dialog-input">
              <div class="filter-label">
                <label>
                  {{ dialogConfig.statisticals.labelKey | xTranslate }}
                  <span class="required-icon" *ngIf="dialogConfig.statisticals.required"> * </span>
                </label>
                <mat-icon
                  svgIcon="mapinfo-icon"
                  class="icon-class ml-2"
                  [matTooltip]="dialogConfig.statisticals.toolTip | xTranslate"
                  *ngIf="historicalStatChanges"
                ></mat-icon>
              </div>
              <div class="market-select">
                <p-select
                  class="primeng-dropdown"
                  [appendTo]="'body'"
                  [options]="dialogConfig.statisticals.data"
                  [formControlName]="dialogConfig.statisticals.key"
                  [filter]="true"
                  filterBy="value,label"
                  [resetFilterOnHide]="true"
                  [autofocus]="true"
                  [showClear]="true"
                  [style]="{ width: '100%' }"
                  [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                  *ngIf="!historicalStatChanges"
                >
                  <ng-template let-selectedStatistical pTemplate="selectedItem">
                    <div>{{ selectedStatistical.label | titlecase }}</div>
                  </ng-template>
                  <ng-template let-statistical pTemplate="item">
                    <div>{{ statistical.label | titlecase }}</div>
                  </ng-template>

                  <!-- Clear icon-->
                  <ng-template pTemplate="clearicon">
                    <i class="pi pi-times-circle property-multiselect-clear"></i>
                  </ng-template>
                </p-select>
                <p-multiSelect
                  class="primeng-multiselect"
                  [appendTo]="'body'"
                  [options]="dialogConfig.statisticals.data"
                  [formControlName]="dialogConfig.statisticals.key"
                  [filter]="true"
                  filterBy="value,label"
                  [resetFilterOnHide]="true"
                  [autofocus]="true"
                  [showClear]="true"
                  [style]="{ width: '100%' }"
                  [placeholder]="'recordsSearch.select' | xTranslate | titlecase"
                  *ngIf="historicalStatChanges"
                >
                  <ng-template let-selectedStatistical pTemplate="selectedItem">
                    <div>{{ selectedStatistical.label | titlecase }}</div>
                  </ng-template>
                  <ng-template let-statistical pTemplate="item">
                    <div>{{ statistical.label | titlecase }}</div>
                  </ng-template>

                  <!-- Clear icon-->
                  <ng-template pTemplate="clearicon">
                    <i class="pi pi-times-circle property-multiselect-clear"></i>
                  </ng-template>
                </p-multiSelect>
              </div>
            </div>
          </ng-container>

          <!-- Date Range Inputs, currently used by Top Transactions & National TIM Reports -->
          <ng-container *ngIf="dialogConfig.date">
            <ng-container [ngTemplateOutlet]="dateRange" [ngTemplateOutletContext]="{ rangeConfig: dialogConfig.date }">
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- ********************************* TEMPLATES ********************************* -->

      <!-- NOTE: Templates must be inside the form element because it has the searchFormGroup embedded -->

      <!-- Number Range Inputs Template -->
      <ng-template #numberRangeInput let-rangeConfig="rangeConfig">
        <div class="report-dialog-input">
          <label>{{ rangeConfig.labelKey | xTranslate | titlecase }}</label>
          <div class="range-fields">
            <ng-container
              [ngTemplateOutlet]="numberInput"
              [ngTemplateOutletContext]="{ inputConfig: rangeConfig.from }"
            ></ng-container>
            <ng-container
              [ngTemplateOutlet]="numberInput"
              [ngTemplateOutletContext]="{ inputConfig: rangeConfig.to }"
            ></ng-container>
          </div>
        </div>
        <ng-template #numberInput let-inputConfig="inputConfig">
          <div class="range-fields__input" [formGroupName]="rangeConfig.key">
            <mat-form-field appearance="outline" class="miq-form-input">
              <input
                matInput
                miqOnlyNumbers
                type="number"
                autocomplete="no-autofill"
                min="0"
                [placeholder]="inputConfig.labelKey | xTranslate"
                [formControlName]="inputConfig.key"
              />
            </mat-form-field>
          </div>
        </ng-template>
      </ng-template>

      <!-- Date Range Inputs Template -->
      <ng-template #dateRange let-rangeConfig="rangeConfig">
        <div class="report-dialog-input">
          <label>
            {{ rangeConfig.labelKey | xTranslate | titlecase }}
            <ng-container *ngIf="rangeConfig.required">
              <span class="required-icon"> &#x2a; </span>
            </ng-container>
          </label>
          <div class="range-fields">
            <ng-container
              [ngTemplateOutlet]="dateInput"
              [ngTemplateOutletContext]="{ inputConfig: rangeConfig.from }"
            ></ng-container
            ><ng-container
              [ngTemplateOutlet]="dateInput"
              [ngTemplateOutletContext]="{ inputConfig: rangeConfig.to }"
            ></ng-container>
          </div>
        </div>
        <ng-template #dateInput let-inputConfig="inputConfig">
          <div class="range-fields__input" [formGroupName]="rangeConfig.key">
            <mat-form-field appearance="outline" class="detaildate-input miq-form-input">
              <input
                matInput
                autocomplete="no-autofill"
                [matDatepicker]="equalDatePicker"
                [max]="inputConfig.maxVal"
                [formControlName]="inputConfig.key"
                [placeholder]="inputConfig.labelKey | xTranslate"
              />
              <i
                *ngIf="(searchFormGroup.controls[rangeConfig.key]?.controls)[inputConfig.key]?.value != null"
                class="pi pi-times-circle close-icon-on-date"
                aria-label="Close icon"
                (click)="clearValue([rangeConfig.key, inputConfig.key])"
              >
              </i>
              <mat-datepicker-toggle matSuffix [for]="equalDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #equalDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </ng-template>
      </ng-template>

      <!-- ********************************* TEMPLATES ********************************* -->
    </form>
  </div>
  <div mat-dialog-actions class="saveSearch-dialog-actions__wrapper">
    <div class="warning-message__container">
      <ng-container *ngIf="warningBtnMsg">
        <div class="warning-message__icon">
          <mat-icon svgIcon="alert-icon"></mat-icon>
        </div>
        <div>{{ warningBtnMsg }}</div>
      </ng-container>
    </div>
    <div class="saveSearch-dialog-actions-button__container">
      <button
        mat-flat-button
        color="primary"
        class="flt-right"
        (click)="saveSearch()"
        [disabled]="!searchFormGroup.valid"
        l10nTranslate
      >
        recordsSearch.save
      </button>
    </div>
  </div>
</div>
